import styled from 'styled-components';
import { IconButton } from '@root/src/app/designSystem/buttons/styled';
import colors from '@designSystem/colors';
import Button from '@root/src/app/designSystem/buttons';
import { CloseMark } from '@root/src/assets/images';

export const MenuMobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  background-color: ${colors.lighterGrey};

  z-index: 10;
  width: calc(100vw - 16px);
  height: 100vh;
  top: 0px;
  left: 0px;
`;
export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px;
`;

export const StyledCloseMark = styled(CloseMark)`
  cursor: pointer;
  & path {
    stroke: ${colors.black};
  }
`;

export const MenuIconButton = styled(IconButton)`
  margin-left: 16px;

  & svg {
    & path {
      fill: ${colors.black};
    }
  }

  &:active {
    & svg {
      & path {
        fill: ${colors.black};
      }
    }
  }
`;

export const StyledDropdownMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 32px 16px 32px 16px;
  border: none;
  border-radius: 10px;
`;

export const MobileMenuOption = styled(Button)<{
  noFill?: boolean;
  noStroke?: boolean;
}>`
  background-color: ${colors.lighterGrey};
  color: ${colors.green};
  width: 100%;
  justify-content: flex-start;
  font-size: 24px;
  line-height: 32px;
  padding: 32px 32px;
  margin: 4px 0px;

  & svg {
    width: 20px;
    height: 20px;
    margin-right: 15px;

    & path {
      stroke: ${(props) => (props.noStroke ? 'none' : colors.green)};
      fill: ${(props) => (props.noFill ? 'none' : colors.green)};
    }
  }

  &:hover {
    background-color: ${colors.lightGrey};
    color: ${colors.green};

    & svg {
      & path {
        stroke: ${(props) => (props.noStroke ? 'none' : colors.green)};
        fill: ${(props) => (props.noFill ? 'none' : colors.green)};
      }
    }
  }

  &:active {
    background-color: ${colors.grey};
    color: ${colors.green};

    & svg {
      & path {
        stroke: ${(props) => (props.noStroke ? 'none' : colors.green)};
        fill: ${(props) => (props.noFill ? 'none' : colors.green)};
      }
    }
  }
`;

export const MobileMenuDangerOption = styled(MobileMenuOption)`
  color: ${colors.red};

  & svg {
    & path {
      fill: none;
    }
  }

  &:hover {
    color: ${colors.red};

    & svg {
      & path {
        fill: none;
      }
    }
  }

  &:active {
    color: ${colors.red};

    & svg {
      & path {
        fill: none;
      }
    }
  }
`;
